import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import useContactsAdmins from "app/pages/sales-intelligence/sub-modules/contacts-search/hooks/useContactsAdmins";
import { AssetsService } from "app/services/AssetsService";

import {
    StyledAdminSubtitleLines,
    StyledContainer,
    StyledImage,
    StyledImageWrapper,
    StyledSubtitle,
    StyledTextWrapper,
    StyledTitle,
} from "./styles";

const RESTRICTED_COUNTRY_SUBTITLE_ADMIN_LINE1 = "si.account-overview.contacts.restricted-country.subtitle.admin.line1";
const RESTRICTED_COUNTRY_SUBTITLE_ADMIN_LINE2 = "si.account-overview.contacts.restricted-country.subtitle.admin.line2";

const ContactsEmptyTable = () => {
    const { contactsAdmins, isUserManagementAllowed, accountUrl, onCopyEmail, onViewUserManagement } =
        useContactsAdmins();

    return (
        <StyledContainer data-automation="contacts-empty-table">
            <StyledImageWrapper>
                <StyledImage
                    data-automation="signals-empty-state-image"
                    src={AssetsService.assetUrl("/images/sales-intelligence/signals-list.svg")}
                    alt="no signals available"
                />
            </StyledImageWrapper>

            <StyledTextWrapper>
                <I18n
                    data-automation="empty-state-title"
                    translatable={{ key: "si.account-overview.contacts.restricted-country.title" }}
                    element={StyledTitle}
                />
                <StyledSubtitle>
                    {isUserManagementAllowed ? (
                        <StyledAdminSubtitleLines
                            gap="0"
                            alignItems="center"
                        >
                            <I18n
                                data-automation="empty-state-subtitle-line1"
                                translatable={{ key: RESTRICTED_COUNTRY_SUBTITLE_ADMIN_LINE1 }}
                            />
                            <I18n
                                data-automation="empty-state-subtitle-line2"
                                translatable={{ key: RESTRICTED_COUNTRY_SUBTITLE_ADMIN_LINE2 }}
                            />
                        </StyledAdminSubtitleLines>
                    ) : (
                        <I18n
                            data-automation="empty-state-subtitle"
                            translatable={{
                                key: "si.account-overview.contacts.restricted-country.subtitle.user",
                            }}
                        />
                    )}
                    {isUserManagementAllowed || contactsAdmins.length === 0 ? null : (
                        <>
                            {": "}
                            {contactsAdmins.length === 1 ? (
                                <span>{` ${contactsAdmins[0]}`}</span>
                            ) : (
                                <StyledTextWrapper>
                                    {contactsAdmins.map((email) => (
                                        <span key={email}>{email}</span>
                                    ))}
                                </StyledTextWrapper>
                            )}
                        </>
                    )}
                </StyledSubtitle>
                {isUserManagementAllowed ? (
                    <a
                        href={accountUrl}
                        onMouseDown={onViewUserManagement}
                    >
                        <IconButton
                            type="primary"
                            placement="right"
                            iconName="arrow-right"
                        >
                            {translate("si.account-overview.contacts.restricted-country.button.admin")}
                        </IconButton>
                    </a>
                ) : contactsAdmins.length > 0 ? (
                    <IconButton
                        type="primary"
                        placement="left"
                        iconName="copy"
                        onClick={onCopyEmail}
                    >
                        {translate(
                            contactsAdmins.length === 1
                                ? "si.account-overview.contacts.restricted-country.button.user"
                                : "si.account-overview.contacts.restricted-country.button.user.multiple",
                        )}
                    </IconButton>
                ) : null}
            </StyledTextWrapper>
        </StyledContainer>
    );
};

export default ContactsEmptyTable;
